export const environment = {
	production: false,
	public_key_recaptcha: '6Lfx29EUAAAAAHq-9kv5WaObm6Ifxexu-U-YWNL8',
	domain: 'http://localhost:4200',
	key_google_maps: 'AIzaSyBq3BL-vyLER2ILrUCzFKMslE20MmGxoPs',
	url_server_backend: 'https://locker-hub-dev-backend.vivipost.com',
	envName: 'dev',
	token_chatbot:'78795514-10f0-474f-9ac4-8ff47e4ac7af'
};
